import { useEffect } from 'react';

import { useAuthModal } from '../../../../apps/explore/providers/AuthModalProvider';
import type { ShowModalEvent } from '../types';

export const Content = () => {
  const { open } = useAuthModal();

  useEffect(() => {
    const showAuthModal = (event: ShowModalEvent) => {
      open(event.origin);
    };

    window.addEventListener(
      'semboShowAuthModal',
      showAuthModal as EventListener
    );

    return () => {
      window.removeEventListener(
        'semboShowAuthModal',
        showAuthModal as EventListener
      );
    };
  }, []);

  return null;
};
